import React, { lazy } from 'react';
export function VideoSection() {
  return <section className="max-w-5xl mx-auto px-4 py-8 sm:py-12 md:py-16" data-id="element-817">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6 sm:mb-8 md:mb-12" data-id="element-818">
        Mira cómo funciona en la vida real
      </h2>
      <div className="aspect-video bg-gray-200 rounded-lg sm:rounded-xl overflow-hidden shadow-xl sm:shadow-2xl" data-id="element-819">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/anB3GKJtpx6Q4Q9q8wXGLT/madre_leyeno_50_recetas.png" alt="Mamá leyendo 50 Recetas de 15 Minutos con su hija en la cocina" loading="lazy" className="w-full h-full object-cover" data-id="element-820" />
      </div>
      <p className="text-center text-sm sm:text-base md:text-lg text-gray-600 mt-4 sm:mt-6 px-4" data-id="element-821">
        De mamás improvisando bajo presión... a familias cenando tranquilas en
        15 minutos
      </p>
    </section>;
}